/**
 * Функция для валидации и форматирования Telegram логина
 * Извлекает username из ссылок и добавляет @ в начале
 */
export default function getValidTelegram(telegram: string): string {
  if (!telegram) return '';
  
  // Убираем пробелы по краям
  let cleaned = telegram.trim();
  
  // Извлекаем username из различных форматов ссылок:
  // https://t.me/username
  // http://t.me/username
  // t.me/username
  // @username
  // username
  const telegramLinkRegex = /(?:https?:\/\/)?(?:www\.)?(?:t\.me\/|telegram\.me\/|telegram\.dog\/)([a-zA-Z0-9_]{5,32})/i;
  const match = cleaned.match(telegramLinkRegex);
  
  if (match) {
    // Если нашли ссылку, берем username из нее
    cleaned = match[1];
  } else {
    // Убираем @ если есть, чтобы потом добавить его обратно
    cleaned = cleaned.replace(/^@+/, '');
    
    // Убираем любые символы, которые не допустимы в telegram username
    // Telegram username может содержать только буквы (a-z, A-Z), цифры (0-9) и подчеркивания (_)
    // Длина от 5 до 32 символов
    cleaned = cleaned.replace(/[^a-zA-Z0-9_]/g, '');
  }
  
  // Если после очистки ничего не осталось, возвращаем пустую строку
  if (!cleaned) return '';
  
  // Добавляем @ в начале
  return `@${cleaned}`;
}

/**
 * Функция для проверки валидности Telegram username
 * Username должен быть от 5 до 32 символов и содержать только буквы, цифры и подчеркивания
 */
export function isValidTelegramUsername(telegram: string): boolean {
  if (!telegram) return false;
  
  // Убираем @ если есть
  const username = telegram.replace(/^@+/, '');
  
  // Проверяем длину и допустимые символы
  const usernameRegex = /^[a-zA-Z0-9_]{5,32}$/;
  return usernameRegex.test(username);
} 